export default __webpack_public_path__ + "static/media/loading.ed912661.gif";